<div class="-oneX-container">
    <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-col-6">
                <label for="name" id="selectLabel" class="-oneX-dropdown__floatingLabel">Search By</label>
                <select id="name" type="text" class="-oneX-dropdown" formControlName="selectedMethod"
                    (change)="selectedMethodFunc($event)">
                    <option *ngFor="let method of methods" [value]="method">
                        {{ method }}
                    </option>
                </select>
            </div>
        </div>
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-col-6" formGroupName="searchMethod">
                <div *ngIf="searchForm.controls.selectedMethod.value  === 'Claim Number'" id="colclaimnum"
                    aria-label="Claim Number" [ngClass]="{'-oneX-widget--err': isInvalidClaimNumber}">
                    <div class="form-group has-feedback" required>
                        <fieldset class="-oneX-fieldset">
                            <label for="conv-textfield" class="-oneX-textfield__label">Claim
                                Number<span>&#42;</span></label>
                            <input id="claimInput"
                                class="-oneX-textfield--conversational-input -oneX-textfield--control"
                                aria-required="true" type="text" style="text-transform: uppercase;" maxlength="9"
                                autocomplete="off" aria-invalid="false" formControlName="claimNumber"
                                aria-describedby="claimNumberAlert" (blur)="errorInClaimNumber()" />
                            <span class="-oneX-contextual-help-container" style="text-align: center;">
                                <button id="claimHelp" aria-label="Claim Number Help"
                                    class="-oneX-contextual-help -oneX-btn-control" aria-expanded="false" tabindex="-1"
                                    type="button">
                                    <div class="-oneX-icon--controls--question"></div>
                                    <div class="-oneX-notch"></div>
                                </button>
                                <span id="claimHelp" id="claimnumberHelpTextContext" tabindex="0"
                                    class="-oneX-contextual-help--text">
                                    <div id="claimnumberHelpText"> Enter the State Farm Claim Number
                                        <br> <br>
                                        <div style="font-size: 20px;">99XXXXXXX </div>
                                        <br> X - Alphanumerical (0-9,A-Z) <br> 9 - Numerical (0-9)
                                    </div>
                                    <button aria-label="Close Help" class="-oneX-close-X-button">
                                        <span class="-oneX-icon--close">
                                        </span>
                                    </button>
                                </span>
                            </span>
                        </fieldset>
                        <div id="claim-err" class="-oneX-widget__err-text" aria-live="assertive"
                            *ngIf="isInvalidClaimNumber">{{claimErrorMsg}}</div>
                    </div>
                </div>
                <div *ngIf="searchForm.controls.selectedMethod.value == 'Policy Number'" id="colpolicynum"
                    aria-label="Policy Number" [ngClass]="{'-oneX-widget--err': isInvalidPolicyNumber }">
                    <div class="form-group has-feedback" required>
                        <fieldset class="-oneX-fieldset">
                            <label for="policyInput" class="-oneX-textfield__label">Policy
                                Number<span>&#42;</span></label>
                            <input id="policyInput"
                                class="-oneX-textfield--conversational-input -oneX-textfield--control"
                                aria-required="true" style="text-transform: uppercase;" type="text"
                                aria-invalid="false" autocomplete="off"
                                formControlName="policyNumber" aria-describedby="policyNumberAlert" maxlength="15"
                                (blur)="errorInPolicyNumber()" />
                            <span class="-oneX-contextual-help-container" style="text-align: center;">
                                <button tabindex="-1" id="polHelpBtn" aria-expanded="false"
                                    aria-label="Policy Number Help" role="button"
                                    class="-oneX-contextual-help -oneX-btn-control" type="button">
                                    <div class="-oneX-icon--controls--question"></div>
                                    <div class="-oneX-notch"></div>
                                </button>
                                <span id="policyNumberHelpTextContext" tabindex="0"
                                    class="-oneX-contextual-help--text  ">
                                    <div id="policyNumberHelpText" class="">
                                        Enter the State Farm Policy Number
                                        <br>
                                        <br>
                                        <div style="font-size: 20px;">XXXXXXXA9999A </div>
                                        <br> X - Alphanumerical (0-9,A-Z) <br> 9 - Numerical (0-9) <br> A - Alphabetic
                                        (A-Z)
                                    </div>
                                    <button aria-label="Close Help" class="-oneX-close-X-button">
                                        <span class="-oneX-icon--close">
                                        </span>
                                    </button>
                                </span>
                            </span>
                        </fieldset>
                        <div id="policy-err" class="-oneX-widget__err-text" aria-live="assertive"
                            *ngIf="isInvalidPolicyNumber">{{policyErrorMsg}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-col-6">
                <div id="coldate" aria-labelledby="dol" aria-label="Date of Loss (MM-DD-YYYY)"
                    [ngClass]="{'-oneX-widget--err': isInvalidDOL}">
                    <div class="form-group has-feedback" required>

                        <fieldset class="-oneX-fieldset">
                            <label for="dateInput" class="-oneX-textfield__label">Date of Loss<span>&#42;</span></label>
                            <input class="-oneX-textfield--conversational-input -oneX-textfield--control"
                                aria-invalid="false" type="text" id="dateInput" name="dol" autocomplete="off"
                                data-formatter="date" aria-required="true" maxlength="10" (blur)="errorInDateOfLoss()"
                                aria-describedby="dateOfLossAlert" formControlName="dateOfLoss" />
                            <button tabindex="-1" class="-oneX-btn-control" type="button">
                                <div tabindex="-1" aria-label="datepicker" role="img"
                                    class="-oneX-icon--controls--calendar"></div>
                            </button>
                        </fieldset>
                        <div id="dol-err" class="-oneX-widget__err-text" aria-live="assertive" *ngIf="isInvalidDOL">
                            {{dateOfLossErrorMsg}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-col-6">
                <div id="colfname" [ngClass]="{'-oneX-widget--err':isInvalidFirstName}" aria-labelledby="fname"
                    aria-label="First Name">
                    <div class="form-group has-feedback">
                        <fieldset class="-oneX-fieldset">
                            <label for="fnameInput" class="-oneX-textfield__label">First Name<span>&#42;</span></label>
                            <input id="fnameInput" type="text" aria-required="true" aria-invalid="false"
                                autocomplete="off"
                                class="-oneX-textfield--conversational-input -oneX-textfield--control"
                                (blur)="errorInFirstName()" aria-describedby="firstNameAlert"
                                formControlName="firstName" />
                            <span class="-oneX-contextual-help-container -oneX-closed">
                                <button aria-label="First Name Help" role="button"
                                    class="-oneX-contextual-help -oneX-btn-control" tabindex="-1" type="button">
                                    <div class="-oneX-icon--controls--question"></div>
                                    <div class="-oneX-notch"></div>
                                </button>
                                <span id="firstNameHelp" tabindex="0" class="-oneX-contextual-help--text">
                                    <div id="firstNameHelp1"> Enter the first name of the patient involved in the loss
                                    </div>
                                    <button aria-label="Close Help" class="-oneX-close-X-button">
                                        <span class="-oneX-icon--close">
                                        </span>
                                    </button>
                                </span>
                            </span>
                        </fieldset>
                        <div id="fname-err" class="-oneX-widget__err-text" aria-live="assertive"
                            *ngIf="isInvalidFirstName">{{firstNameErrorMsg}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="-oneX-row -oneX-justify-content-center">
            <div class="-oneX-col-6">
                <div id="collname" [ngClass]="{'-oneX-widget--err':isInvalidLastName}" aria-labelledby="lname"
                    aria-label="Last Name">
                    <div class="form-group has-feedback">
                        <fieldset class="-oneX-fieldset">
                            <label for="lnameInput" class="-oneX-textfield__label">Last Name<span>&#42;</span></label>
                            <input id="lnameInput"
                                class="-oneX-textfield--conversational-input -oneX-textfield--control"
                                aria-invalid="false" autocomplete="off" type="text" aria-required="true"
                                formControlName="lastName" (blur)="errorInLastName()"
                                aria-describedby="lastNameAlert" />
                            <span class="-oneX-contextual-help-container -oneX-closed">
                                <button aria-label="Last Name Help" role="button"
                                    class="-oneX-contextual-help -oneX-btn-control" tabindex="-1" type="button">
                                    <div class="-oneX-icon--controls--question"></div>
                                    <div class="-oneX-notch"></div>
                                </button>
                                <span id="lastNameHelp" tabindex="0" class="-oneX-contextual-help--text">
                                    <div id="lastNameHelp1"> Enter the last name of the patient involved in the loss
                                    </div>
                                    <button aria-label="Close Help" class="-oneX-close-X-button">
                                        <span class="-oneX-icon--close">
                                        </span>
                                    </button>
                                </span>
                            </span>
                        </fieldset>
                        <div id="lname-err" class="-oneX-widget__err-text" aria-live="assertive"
                            *ngIf="isInvalidLastName">{{lastNameErrorMsg}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="-oneX-row"><br></div>
        <div class="-oneX-row -oneX-justify-content-center">
            <button tabindex="0" id="buttonid" class="-oneX-btn-primary -oneX-btn-fit-content"
                type="submit">Submit</button>
        </div>
    </form>
</div>